'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.lesson', {
    url: '/lesson/:lessonId',
    resolve: {
      lesson: function (module, $stateParams, $q) {
        return _.find(module.lessons, { _id: $stateParams.lessonId }) || $q.reject({ status: 404 });
      }
    },
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/lesson/lesson.html',
        controller: function ($scope, $state, $viewport, module, lesson, instance, rmGuide) {
          $scope.module = module;
          $scope.lesson = lesson;
          if ($state.is('instance.app.module.lesson')) {
            $state.go('.introduction');
          }
        }
      }
    }
  });

});
